'use strict';

/**
 * Do not edit directly, this file was auto-generated.
 */

var light = {
  "theme": "light",
  "surface": {
    "overlayBackdrop": "#00000033",
    "level0": "#ffffff",
    "level1": "#f5f7fa",
    "raised": "#ffffff",
    "overflow": "#ffffff",
    "inverse": "#2e3a47",
    "overlay": "#ffffff",
    "overlayInverted": "#2e3a47"
  },
  "brand": {
    "googleButtonText": "#1f1f1f",
    "googleButtonBorder": "#747775",
    "googleButtonFill": "#ffffff",
    "fullscriptLogo": "#88b04b",
    "facebookLogo": "#3c5a99",
    "linkedinLogo": "#2867b2",
    "appleButtonText": "#000000",
    "appleButtonBorder": "#000000",
    "appleButtonFill": "#ffffff",
    "twitterXLogo": "#000000"
  },
  "inverse": {
    "text": "#f5f7fa",
    "textBold": "#ffffff",
    "icon": "#f5f7fa",
    "backgroundMuted": "#36485c",
    "backgroundBold": "#212933",
    "border": "#212933"
  },
  "neutral": {
    "textSubtle": "#475a70",
    "text": "#36485c",
    "textBold": "#2e3a47",
    "icon": "#36485c",
    "backgroundLevel0": "#ffffff",
    "backgroundLevel1": "#f5f7fa",
    "borderMuted": "#f5f7fa",
    "border": "#b8c6d6",
    "borderBold": "#596d84",
    "separator": "#c8d3e0"
  },
  "recur": {
    "text": "#3b2566",
    "textBold": "#2a174f",
    "icon": "#3b2566",
    "backgroundMuted": "#f2ecfe",
    "backgroundBold": "#533e7d",
    "border": "#533e7d"
  },
  "critical": {
    "text": "#980b29",
    "textBold": "#800d25",
    "icon": "#980b29",
    "backgroundMuted": "#feeef2",
    "backgroundBold": "#af2645",
    "border": "#af2645"
  },
  "info": {
    "text": "#21588f",
    "textBold": "#194673",
    "icon": "#21588f",
    "backgroundMuted": "#e6f1fc",
    "backgroundBold": "#3971a8",
    "border": "#3971a8"
  },
  "warning": {
    "text": "#8e4d14",
    "textBold": "#784213",
    "icon": "#8e4d14",
    "backgroundMuted": "#fff3e8",
    "backgroundBold": "#8e4d14",
    "border": "#b4631d"
  },
  "success": {
    "text": "#275e43",
    "textBold": "#244c38",
    "icon": "#275e43",
    "backgroundMuted": "#ebf2ef",
    "backgroundBold": "#307553",
    "border": "#307553"
  },
  "discovery": {
    "text": "#90805b",
    "textBold": "#5e4d27",
    "icon": "#90805b",
    "backgroundMuted": "#f6f1e5",
    "backgroundBold": "#a89976",
    "border": "#a89976"
  },
  "smart": {
    "backgroundBold1": "#7495b9",
    "backgroundBold2": "#4d7199",
    "backgroundBold3": "#2e5988"
  },
  "accent": {
    "orangeText": "#8e4d14",
    "orangeTextBold": "#784213",
    "orangeIcon": "#8e4d14",
    "orangeBackgroundMuted": "#fff3e8",
    "orangeBackgroundBold": "#8e4d14",
    "orangeBorder": "#b4631d",
    "blueText": "#21588f",
    "blueTextBold": "#194673",
    "blueIcon": "#21588f",
    "blueBackgroundMuted": "#e6f1fc",
    "blueBackgroundBold": "#3971a8",
    "blueBorder": "#3971a8",
    "redText": "#980b29",
    "redTextBold": "#800d25",
    "redIcon": "#980b29",
    "redBackgroundMuted": "#feeef2",
    "redBackgroundBold": "#af2645",
    "redBorder": "#af2645",
    "purpleText": "#3b2566",
    "purpleTextBold": "#2a174f",
    "purpleIcon": "#3b2566",
    "purpleBackgroundMuted": "#f2ecfe",
    "purpleBackgroundBold": "#533e7d",
    "purpleBorder": "#533e7d",
    "greenText": "#275e43",
    "greenTextBold": "#244c38",
    "greenIcon": "#275e43",
    "greenBackgroundMuted": "#ebf2ef",
    "greenBackgroundBold": "#307553",
    "greenBorder": "#307553"
  },
  "effect": {
    "elevationOverlay": "#ffffff",
    "elevationOverflowColour": "#36485c29",
    "elevationRaisedColour": "#36485c29",
    "stateFocusedBorder": "#015fcc",
    "stateHoveredBackground": "#00000014",
    "stateHoveredText": "#00000014",
    "stateHoveredIcon": "#00000014",
    "stateHoveredBorder": "#00000014",
    "stateHoveredInverseBackground": "#ffffff14",
    "stateHoveredInverseText": "#ffffff14",
    "stateHoveredInverseIcon": "#ffffff14",
    "stateHoveredInverseBorder": "#ffffff14",
    "stateHoveredInverseBorderBold": "#ffffff52",
    "stateHoveredBorderBold": "#00000052",
    "statePressedBackground": "#0000001f",
    "statePressedText": "#0000001f",
    "statePressedIcon": "#0000001f",
    "statePressedBorder": "#0000001f",
    "statePressedInverseBackground": "#ffffff1f",
    "statePressedInverseText": "#ffffff1f",
    "statePressedInverseIcon": "#ffffff1f",
    "statePressedInverseBorder": "#ffffff1f",
    "statePressedInverseBorderBold": "#ffffffcc",
    "statePressedBorderBold": "#000000cc",
    "stateDisabledOpacity": "0.6",
    "stateReadOnlyOpacity": "0.8"
  },
  "asset": {
    "green_100": "#fafffc",
    "green_200": "#ebf2ef",
    "green_300": "#d1e0d9",
    "green_400": "#b6cfc2",
    "green_500": "#86b09b",
    "green_600": "#307553",
    "green_700": "#275e43",
    "green_800": "#244c38",
    "green_900": "#0f3d26",
    "greenBackground": "#d1e0d9",
    "greenBackItem": "#86b09b",
    "red_100": "#fff7f9",
    "red_200": "#feeef2",
    "red_300": "#f0c4cd",
    "red_400": "#e296a6",
    "red_500": "#c6516a",
    "red_600": "#af2645",
    "red_700": "#980b29",
    "red_800": "#800d25",
    "red_900": "#68182a",
    "redBackground": "#f0c4cd",
    "redBackItem": "#c6516a",
    "purple_100": "#fcfaff",
    "purple_200": "#f2ecfe",
    "purple_300": "#d7cee9",
    "purple_400": "#b9abd5",
    "purple_500": "#8471ab",
    "purple_600": "#533e7d",
    "purple_700": "#3b2566",
    "purple_800": "#2a174f",
    "purple_900": "#17043e",
    "purpleBackground": "#d7cee9",
    "purpleBackItem": "#8471ab",
    "orange_100": "#fffaf5",
    "orange_200": "#fff3e8",
    "orange_300": "#f3d8c0",
    "orange_400": "#e7b88f",
    "orange_500": "#cf8545",
    "orange_600": "#b4631d",
    "orange_700": "#8e4d14",
    "orange_800": "#784213",
    "orange_900": "#693a11",
    "orangeBackground": "#f3d8c0",
    "orangeBackItem": "#cf8545",
    "blue_100": "#f5faff",
    "blue_200": "#e6f1fc",
    "blue_300": "#c0d8f0",
    "blue_400": "#88b1d9",
    "blue_500": "#5d96cf",
    "blue_600": "#3971a8",
    "blue_700": "#21588f",
    "blue_800": "#194673",
    "blue_900": "#143657",
    "blueBackground": "#c0d8f0",
    "blueBackItem": "#5d96cf",
    "grey_100": "#fcfeff",
    "grey_200": "#f5f7fa",
    "grey_300": "#e6edf5",
    "grey_400": "#c8d3e0",
    "grey_500": "#596d84",
    "grey_600": "#475a70",
    "grey_700": "#36485c",
    "grey_800": "#2e3a47",
    "grey_900": "#212933",
    "greyBackground": "#c8d3e0",
    "greyBackItem": "#596d84",
    "sand_100": "#ffffff",
    "sand_200": "#f6f1e5",
    "sand_300": "#efe8da",
    "sand_400": "#e4d9c2",
    "sand_500": "#c6b795",
    "sand_600": "#a89976",
    "sand_700": "#90805b",
    "sand_800": "#5e4d27",
    "sand_900": "#3e3114",
    "sandBackground": "#efe8da",
    "sandBackItem": "#c6b795",
    "shadeWhite": "#ffffff"
  },
  "button": {
    "secondarySmartText": "#2e3a47",
    "secondarySmartIcon": "#36485c",
    "secondaryCriticalText": "#800d25",
    "secondaryCriticalBorder": "#af2645",
    "secondaryCriticalIcon": "#980b29",
    "tertiaryInverseText": "#ffffff",
    "tertiaryInverseIcon": "#f5f7fa"
  },
  "checkbox": {
    "text": "#36485c",
    "border": "#596d84",
    "icon": "#f5f7fa",
    "selected": "#212933",
    "background": "#ffffff"
  },
  "input": {
    "defaultText": "#36485c",
    "defaultBorder": "#b8c6d6",
    "defaultIcon": "#36485c",
    "background": "#ffffff",
    "criticalText": "#980b29",
    "criticalBorder": "#af2645",
    "criticalIcon": "#980b29"
  },
  "search": {
    "text": "#36485c",
    "border": "#b8c6d6",
    "background": "#ffffff",
    "icon": "#36485c"
  },
  "iconButton": {
    "primaryDefaultBackground": "#36485c",
    "primaryDefaultIcon": "#f5f7fa",
    "primaryInverseBackground": "#f5f7fa",
    "primaryInverseIcon": "#36485c",
    "primarySmartIcon": "#f5f7fa",
    "primaryCriticalIcon": "#f5f7fa",
    "primaryCriticalBackground": "#af2645",
    "secondaryDefaultBorder": "#212933",
    "secondaryDefaultIcon": "#36485c",
    "secondaryInverseBorder": "#f5f7fa",
    "secondaryInverseIcon": "#f5f7fa",
    "secondarySmartIcon": "#36485c",
    "secondaryCriticalBorder": "#af2645",
    "secondaryCriticalIcon": "#980b29",
    "tertiaryDefaultIcon": "#36485c",
    "tertiaryInverseIcon": "#f5f7fa"
  },
  "box": {
    "defaultBorder": "#b8c6d6",
    "defaultBackground": "#f5f7fa",
    "alternateBorder": "#b8c6d6",
    "alternateBackground": "#ffffff",
    "discoveryBorder": "#a89976",
    "discoveryBackground": "#f6f1e5",
    "recurBorder": "#533e7d",
    "recurBackground": "#f2ecfe",
    "slotText": "#2e3a47",
    "slotBorder": "#b8c6d6",
    "slotIcon": "#36485c"
  },
  "link": {
    "inverseText": "#f5f7fa",
    "inverseIcon": "#f5f7fa"
  },
  "radio": {
    "text": "#36485c",
    "border": "#596d84",
    "selected": "#212933",
    "background": "#ffffff"
  },
  "dotBadge": {
    "default": "#36485c",
    "warning": "#8e4d14",
    "info": "#3971a8",
    "recur": "#533e7d",
    "success": "#307553",
    "critical": "#af2645",
    "inverse": "#f5f7fa",
    "discover": "#a89976"
  }
};

exports.light = light;
//# sourceMappingURL=light.cjs.map
